import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const ChevronLeftOutlinedSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 8.00002L9.50005 13L10.49 12.01L6.47991 8.00002L10.49 3.98996L9.5001 3L4.5 8.00002Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const ChevronLeftOutlinedSize16 = hoc(forwardRef(ChevronLeftOutlinedSize16Component), 'ChevronLeftOutlinedSize16');

export { ChevronLeftOutlinedSize16 as default };
//# sourceMappingURL=ChevronLeftOutlinedSize16.js.map
